export default class Utilities {
    static getWPUserState() {
        let s = window.localStorage.getItem('hwui');
        return s ? JSON.parse(atob(s)) : null;
    }

    static preloadTestUser() {
        let t = {
            "id": "5",
            "display_name": "Raphael",
            "email": "raphael@bitmotive.com",
            "user_registered": "2021-11-29 18:02:36",
            "credits": "1",
            "vouchers": [
                {
                    "id": "OrJTjweXyBsvqDLHu5SE",
                    "created_on": "2022-03-25 22:11:58",
                    "type": "booking",
                    "project_id": "dc27adf7-c023-46ec-9d54-2fe0f94139d3",
                    "redeemed": false
                },
                {
                    "id": "BLAH",
                    "created_on": "2022-03-25 22:11:58",
                    "type": "guest",
                    "project_id": "",
                    "redeemed": false
                }
            ],
        };
        
        window.localStorage.setItem('hwui', btoa(JSON.stringify(t)));
        window.localStorage.setItem('hwnonce', '595b7e9daf');
    }

    static pluralize(value, single, multiple, include = true) {
        if(include) {
            return value == 1 ? `${Number(value)} ${single}` : `${Number(value)} ${multiple}`;
        } else {
            return value == 1 ? `${single}` : `${multiple}`;
        }
    }

    static querify(base, queries) {
        let link = base + '?';

        for(let q of queries) {
            if(q[1]) {
                link += `${q[0]}=${encodeURIComponent(q[1])}`;
            }
        }

        return link.substring(0, link.length-1);
    }

    static autoclass(styleRack) {
        let s = "";
        for(var [className, condition] of Object.entries(styleRack)) {
            s += condition ? `${className} ` : "";
        }
        return s.trimEnd();
    }

    static genString(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    static clamp(number, min, max) {
        return Math.max(min, Math.min(number, max));
    }

    static sameDay(date1, date2) {
        return date1.getDate() === date2.getDate() &&
               date1.getMonth() === date2.getMonth() &&
               date1.getFullYear() === date2.getFullYear();
    }
}